import Manager from "../manager/Manager.api";
import Endpoints from "../endpoints/Endpoints.api";
import useSWR from "swr";

const changeGamesLimits = (card, token, area, data) =>
  Manager.client().post(Endpoints.privateArea.changeGamesLimits, {
    card,
    token,
    area,
    ...data,
  });

const gamesLimits = (card, token, language, data) =>
  Manager.client().post(Endpoints.privateArea.games_limits, {
    card,
    token,
    language,
    ...data,
  });

const setGlobalLimit = (card, token, amount, language) =>
  Manager.client().post(Endpoints.privateArea.setGlobalLimit, {
    card,
    token,
    amount,
    language,
  });

export const UseUserGamesLimits = (card, token, language) => {
  const key = `${Endpoints.privateArea.games_limits}/`;
  const { data, error } = Manager.client().post(key, {
    card,
    token,
    language,
  });

  return {
    data: data ? data.data.data : null,
    error,
    loading: !error && !data,
  };
};

export const useSetGlobalLimit = async (card, token, amount, language) => {
  const { data, error } = await setGlobalLimit(card, token, amount, language);
  return {
    data: data && data.data ? data.data : null,
    error,
    loading: !error && !data,
  };
};

const winningLimits = (card, token, language) =>
  Manager.client().post(Endpoints.privateArea.get_winning_threshold, {
    card,
    token,
    language,
  });

const setNewLimits = (card, token, language, amount) =>
  Manager.client().post(Endpoints.privateArea.set_winning_threshold, {
    card,
    token,
    language,
    amount,
  });

export const UseWinningLimits = async ({ card, token, language }) => {
  const { data, error } = await winningLimits(card, token, language);
  return {
    data: data ? data.data : null,
    error,
    loading: !error && !data,
  };
};

export const SetWinningLimits = async ({ card, token, language, amount }) => {
  const { data, error } = await setNewLimits(card, token, language, amount);
  return {
    data: data ? data.data : null,
    error,
    loading: !error && !data,
  };
};

export const Request = {
  changeGamesLimits,
  UseUserGamesLimits,
  gamesLimits,
};
